<script>
import toasts from "../../mixins/toasts";

export default Vue.extend({
  mixins: [toasts],
  props: ["group"],
  data() {
    return {
      checkedPreviewLimit: 20,
      initialLoad: true,
      loading: false,
      checked: [],
      checkedNew: [],
      users: [],
      userModal: {
        active: false
      },
      editModal: {
        active: false
      },
      data: this.group,
      count: 0
    };
  },
  computed: {
    leaders() {
      return _.filter(this.users, user => {
        return this.isLeader(user);
      });
    }
  },
  methods: {
    back: function() {
      window.history.back();
    },
    edit: function() {
      this.editModal.active = true;
    },
    save: function() {
      this.$refs.form.save().then(data => {
        this.data = data;
        this.closeModal();
      });
    },
    remove: function() {
      this.$dialog.confirm({
        title: "Удаление группы",
        message:
          `Вы уверены, что хотите удалить <br>` +
          `группу <b>${this.group.title}</b>?<br>` +
          `Все студенты будут автоматически исключены из неё.`,
        confirmText: "Удалить группу",
        cancelText: "Отмена",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          axios
            .delete(`/api/groups/${this.group.id}`)
            .then(response => {
              this.toast("success", "Группа была успешно удалена");
              _.delay(() => {
                window.open(`/users/groups/${this.group.type}`, "_self");
              }, 2000);
            })
            .catch(error => {
              this.toast("error", "@unexpected", error);
              loading.close();
            });
        }
      });
    },
    refreshList: function() {
      let loading = this.$loading.open();

      axios
        .get(`/api/groups/${this.group.id}/students`)
        .then(response => {
          this.users = [];
          response.data.data.forEach(user => {
            this.users.push(user);
          });
          this.initialLoad = false;
          loading.close();
        })
        .catch(error => {
          this.toast("error", "@unexpected", error);
          loading.close();
        });
    },
    isLeader(user) {
      return user.is_leader === true;
    },
    studentFilter: function(user) {
      switch (this.group.type) {
        case "regular": {
          return user.profile.regular_group == null;
        }
        case "graduate": {
          return user.profile.graduate_group == null;
        }
        case "master": {
          return user.profile.master_group == null;
        }
        case "bachelor": {
          return user.profile.bachelor_group == null;
        }
        case "linguistic": {
          let linguistic = this.group.details.subject.details.linguistic;
          if (linguistic == "primary") {
            return user.profile.primary_language_group == null;
          } else {
            return user.profile.secondary_language_group == null;
          }
        }
        case "optional": {
          if (user.profile.optional_groups.length > 0) {
            return (
              _.some(user.profile.optional_groups, {
                id: this.group.id
              }) == false
            );
          } else {
            return true;
          }
        }
      }
    },
    addStudents: function() {
      let loading = this.$loading.open();
      let list = _.map(this.checkedNew, "id").join(",");
      axios
        .post(`/api/groups/${this.group.id}/students/${list}`)
        .then(response => {
          loading.close();
          this.toast("success", "Студенты были успешно добавлены");
          this.closeModal();
          this.refreshList();
        })
        .catch(error => {
          this.toast("error", "@unexpected", error);
          loading.close();
        });
    },
    removeStudents: function() {
      let list = this.checked.map(user => {
        return user.full_name;
      });

      this.$dialog.confirm({
        title: "Исключить студентов",
        message:
          `Вы уверены, что хотите исключить из группы:<br>` +
          `<b>${list.join("<br>")}</b>`,
        confirmText: "Исключить",
        cancelText: "Отмена",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          let loading = this.$loading.open();

          let list = this.checked.map(user => {
            return user.id;
          });

          axios
            .delete(`/api/groups/${this.group.id}/students/${list.join(",")}`)
            .then(response => {
              this.checked = [];
              this.toast("success", "Студенты были исключены из группы");
              loading.close();
              this.refreshList();
            })
            .catch(error => {
              this.toast(
                "error",
                _.get(error, "response.data.error", "@unexpected")
              );
              loading.close();
            });
        }
      });
    },
    openModal: function() {
      this.loading = true;
      this.checkedNew = [];
      this.userModal.ready = false;
      this.userModal.active = true;
    },
    closeModal: function() {
      // Clear user modal URL options
      this.$router.replace({
        query: {}
      });
      this.userModal.active = false;
      this.editModal.active = false;
    },
    check: function(checked) {
      this.checkedNew = [];
      checked.forEach(user => {
        this.checkedNew.push(user);
      });
    },
    initialized: function() {
      this.loading = false;
      this.userModal.ready = true;
    }
  },
  created() {
    this.refreshList();
    this.closeModal();
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/groups/Show.vue